/* GENERATED by scripts/design-system/build-client-logo-sizes.mjs; do not edit.
   Run npm run build:logo-sizes after changing a logo or clientLogos.json.
   input-hash: f667d58a445fdaca */

/** The client logo sprite. The query string changes with every logo or
    tuning change, so the file can be cached immutably. */
export const CLIENT_LOGO_SPRITE_URL = "/logos/client-logo-sprite.svg?v=f667d58a445fdaca";
